import './rotate-warning.styles.scss';

const RotateWarning = () => {
    return (
        <span className='screen-rotate-warning rotate-warning'>
            Please rotate your screen to landscape!
        </span>
    )
}

export default RotateWarning;